import { configureStore, combineReducers } from "@reduxjs/toolkit";

/* AUTH */
import authReducer from "../auth/authSlice";

/* ADMIN */
import branchReducer from "./admin/branch.slice";
import studentReducer from "./admin/student.slice";
import studentReportReducer from "./admin/studentReport.slice"; // ✅ Added
import studentPerformanceReducer from "./admin/studentPerformance.slice"; // ✅ Import new slice
import userAccountsReducer from "./admin/userAccounts.slice";
import feesReducer from "./admin/fees.slice";
import tournamentParticipantsReducer from "./admin/tournamentParticipants.slice";
import tournamentsReducer from "./admin/tournaments.slice";
import tournamentExpensesReducer from "./admin/tournamentExpenses.slice";
import tournamentExpenseCategoriesReducer from "./admin/tournamentExpenseCategories.slice";
import profitLossReducer from "./admin/profitLoss.slice";
import sessionMasterReducer from "./admin/sessionMaster.slice";
import sessionInfoReducer from "./admin/sessionInfo.slice";
import homeworkMasterReducer from "./admin/homeworkMaster.slice";
import homeworkSubmissionReducer from "./admin/homeworkSubmission.slice";
import courseCategoryReducer from "./admin/courseCategory.slice";
import courseInstructor from "./admin/courseInstructor.slice";
import bookReducer from "./admin/book.slice";
import investorReducer from "./admin/investor.slice"; // ✅ Import investor slice
import investmentsReducer from "./admin/investments.slice"; // ✅ Import investments slice
import investmentTransactionsReducer from "./admin/investmentTransactions.slice"; // ✅ Import investment transactions slice
import academyExpenseReducer from "./admin/academyExpense.slice"; // ✅ Import academy expense slice
import feeMasterReducer from "./admin/fee_master.slice"; // ✅ Import fee master slice
import studentFeePlanReducer from "./admin/student_fee_plan.slice"; // ✅ Import student fee plan slice
import feeReportsReducer from "./admin/fee_reports.slice"; // ✅ Import fee reports slice

/* ADMIN DOMAIN */
const adminReducer = combineReducers({
  branches: branchReducer,
  students: studentReducer,
  studentReport: studentReportReducer, // ✅ Connected here for state.admin.studentReport
  studentPerformance: studentPerformanceReducer, // ✅ Added to admin object
  userAccounts: userAccountsReducer, // ✅ Added
  fees: feesReducer,
  feeMaster: feeMasterReducer, // ✅ Connected fee master slice
  studentFeePlan: studentFeePlanReducer, // ✅ Connected student fee plan slice
  feeReports: feeReportsReducer, // ✅ Connected fee reports slice
  tournamentParticipants: tournamentParticipantsReducer,
  tournaments: tournamentsReducer,
  courseCategory: courseCategoryReducer,
  book: bookReducer, // ✅ Added
  courseInstructor: courseInstructor,
  sessionMaster: sessionMasterReducer,
  homeworkMaster: homeworkMasterReducer,
  homeworkSubmission: homeworkSubmissionReducer,
  sessionInfo: sessionInfoReducer,
   // Tournament Expenses
  tournamentExpenses: tournamentExpensesReducer,
  tournamentExpenseCategories: tournamentExpenseCategoriesReducer,
  profitLoss: profitLossReducer, // ✅ ADD THIS
  investors: investorReducer, // ✅ Connected investor slice
  investments: investmentsReducer, // ✅ Connected investments slice
  investmentTransactions: investmentTransactionsReducer, // ✅ Connected investment transactions slice
  academyExpense: academyExpenseReducer, // ✅ Connected academy expense slice
});

/* ROOT */
const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
